export default "__VITE_ASSET__CXN8Vpxn__"